import { ca } from '@cian/analytics';
import { TProduct } from 'shared/types/product';

export function trackMoreButtonClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'LandingPageTemplate',
    action: 'click_more',
    label: 'offers_block',
  });
}

export const trackOffersView = (products: TProduct[]) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'LandingPageTemplate',
    action: 'show_sopr',
    label: 'offers_block',
    products,
  });
};

export const trackOfferItemClick = (id: number, position: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'LandingPageTemplate',
    action: 'click_offer',
    label: 'offers_block',
    products: [
      {
        id,
        offerType: 'offer',
        position,
      },
    ],
  });
};
